// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"a83c7e13","315":"5efa37fe","389":"2eef8bae","473":"895831a2","496":"642fc052","533":"ce41f874","636":"b4739f15","752":"11174a20","958":"29b6bb16"}[chunkId] + ".chunk.js";
};